/**
 * 08.10.26 — структурные классы холста Linear для экранов нотифаера.
 * Не удалять по требованию владельца системы.
 * Цвета живут в .linear-canvas (globals.css): светлая — белый и синий,
 * тёмная — #010102 и лавандовый #5e6ad2. Здесь только раскладка.
 */

export const linearCanvas = {
  root: 'linear-canvas flex h-full min-h-0 flex-col',
  header: 'flex shrink-0 items-start justify-between gap-6 border-b border-shell-border px-6 py-5',
  eyebrow: 'text-[13px] font-medium uppercase tracking-[0.4px] text-shell-muted',
  title: 'mt-1 text-[28px] font-semibold leading-[1.2] tracking-[-0.6px] text-shell-strong',
  lead: 'mt-2 max-w-3xl text-sm leading-6 text-shell-muted',
  actions: 'flex shrink-0 items-center gap-2',
  toolbar: 'shrink-0 border-b border-shell-border px-6 py-4',
  body: 'min-h-0 flex-1 overflow-y-auto overscroll-contain px-6 py-5',
  card: 'rounded-xl border border-shell-border bg-shell-surface p-6',
  cardTitle: 'text-[22px] font-medium leading-[1.25] tracking-[-0.4px] text-shell-strong',
  meta: 'text-xs leading-5 text-shell-muted',
  chip: 'rounded-md border border-shell-border bg-shell-elevated px-2 py-0.5 text-xs text-shell-muted',
  button:
    'inline-flex h-10 items-center rounded-lg bg-shell-primary px-3.5 text-sm font-medium text-white hover:bg-shell-primary-strong',
  buttonQuiet:
    'inline-flex h-10 items-center rounded-lg border border-shell-border bg-shell-surface px-3.5 text-sm font-medium text-shell-strong hover:bg-shell-hover',
  field:
    'h-10 w-full rounded-lg border border-shell-border bg-shell-surface px-3 text-sm text-shell-text outline-none focus:border-shell-primary',
  notice: 'rounded-xl border border-shell-border bg-shell-primary-soft px-4 py-3 text-sm text-shell-primary-strong',
} as const;
